module.exports = __webpack_public_path__ + "img/landmarks.d7cb2602.svg";